<template>
	<div class="tabWrapper salaryHistory">
		<no-info v-if="this.rowsList && this.rowsList.length <= 0" text="The user does not have information yet paid month"/>
		<div v-else class="main">
			<!-- Кастомные кнопки навигации -->
			<div class="custom-navigation">

				<button class="previous" @click="goPrev">
					<svg-sprite icon-id="previous"></svg-sprite>
				</button>
				<button class="next" @click="goNext" v-show="activeIndex > 0">
					<svg-sprite icon-id="next"></svg-sprite>
				</button>
			</div>

			<swiper
					v-if="rowsList"
					ref="mySwiper"
					:space-between="10"

					:pagination="false"
					:navigation="false"
					dir="rtl"
					:breakpoints="{
				      640: { slidesPerView: 1, },
				      768: { slidesPerView: 2, },
				      1024: { slidesPerView: 2, },
				    }"
					@swiper="onSwiper"
					@slideChange="onSlideChange"

			>
				<swiper-slide
						v-for="(item, index) in rowsList"
						:key="index"
						:item="item"
				>
					<salary-history-slide
							:item="item"
							:months="userPayРistory_months"
							flag="userSalaryHistorySlide"
							@updatePay="onPay"
							@updateEditItem="onEditItem"
					></salary-history-slide>
				</swiper-slide>
			</swiper>
			</div>
		<salary-pay
				v-if="isSalaryPay"
				:activeItem='salaryPayMonth'
				:id="id"
				@updateClose="onSalaryPayClose"
				@updateSave="onSendSalaryPay"
		></salary-pay>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Navigation, Pagination } from 'swiper';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2';
// Import Swiper styles
import 'swiper/swiper-bundle.css';
import SalaryHistorySlide from "@/pages/Account/Tabs/SalaryHistorySlide/SalaryHistorySlide.vue";
import SalaryPay from "@/pages/UserProfile/Drawers/SalaryPay.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import { TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";
SwiperCore.use([ Navigation, Pagination ]);

export default {
	name: "UserTabSalaryHistory",

	components: {
		NoInfo,
		DialogRemove,
		SalaryPay,
		SalaryHistorySlide,
		Swiper,
		SwiperSlide
	},
	computed: {
		...mapGetters([
			'userPayРistory_months',
			'userPayРistory_rows',
			'userPayРistory_first',
		]),
	},
	props: {
		user: Object,
	},
	data: () => ({
		id: null,
		months: null,
		rowsList: null,
		loadMonths: [],
		swiperRef: null,
		activeIndex: 0,
		filteredMonths: null,
		isSalaryPay: false,
		salaryPayMonth: null,

		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
		nameComponent: null,
	}),
	methods: {
		...mapActions([
			'getUserPayРistory',
			'getUserPayРistoryPrev',
			'getUserSalaryPay',
			'deleteUserSalaryPayment',
			'setAlert',
		]),

		onPay(args) {
			const { item } = args;
			this.isSalaryPay = true;
			this.salaryPayMonth = item;
		},
		onSalaryPayClose() {
			this.isSalaryPay = false;
		},
		async onEditItem(args) {
			const { key, item, nameComponent } = args;

			this.nameComponent = nameComponent;
			this.activeItem = item;
			if (nameComponent === 'userSalaryHistorySlide' && key === 'delete1') {
				const title = TITLE.REMOVE_SALARY_PAYMENT;
				const text = TEXT.REMOVE_SALARY_PAYMENT;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			if (this.nameComponent === 'userSalaryHistorySlide') {
				const { id } = this.activeItem;
				await this.deleteUserSalaryPayment(id);
				this.onCloseRemove();
			}
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},

		async onSendSalaryPay(args) {
			await this.getUserSalaryPay(args);

			this.isSalaryPay = false;
		},

		onSwiper(swiper) {
			this.swiperRef = swiper;
		},
		onSlideChange(swiper) {
			this.activeIndex = swiper.activeIndex;
		},

		goNext() {
			this.swiperRef.slidePrev();
		},
		async updateLastRow() {
			// Получить список месяцев из rowsList
			const rowsListMonths = new Set(this.rowsList.map(row => row.month));

			// Фильтровать месяцы из массива months
			this.filteredMonths = this.months.filter(month => !rowsListMonths.has(month.month));

			if (this.filteredMonths.length > 0) {
				const date = this.filteredMonths[0].date;
				const id = this.id;

				const { rows } = await this.getUserPayРistoryPrev({ date, id });

				this.rowsList.push(Object.values(rows)[0]);

				// Обновляем Swiper, чтобы отобразить новый слайд
				this.$nextTick(() => {
					this.swiperRef.update(); // Обновляем Swiper
					this.swiperRef.slideNext(); // Переходим на предыдущий слайд
				});
			} else {
				this.swiperRef.slideNext(); // Переходим на предыдущий слайд
				await this.setAlert({ type: "info", message: "No information for previous month 🤷🗿" });

			}
		},
		goPrev() {
			if ((this.rowsList.length === 2 && this.activeIndex === 0)
					|| (this.rowsList.length === 1 && this.activeIndex === 0)
					|| (this.rowsList.length === this.activeIndex + 2 )) {
				this.updateLastRow();
			} else {
				this.swiperRef.slideNext();
			}
		},
		goToSlide(index) {
			this.swiperRef.slideTo(index);

		}
	},
	async mounted() {
		const {
			id,
		} = this.user;
		this.id = id;

		await this.getUserPayРistory(id);

		this.rowsList = Object.values(this.userPayРistory_rows);
		this.loadMonths = Object.keys(this.userPayРistory_rows);
		this.months = this.userPayРistory_months;

		this.onSwiper(); // Обновляем Swiper
	},

	watch: {
		userPayРistory_first(value, oldValue) {
			if (value !== oldValue) {
				// Ключ для поиска
				const key = Object.keys(value)[0];

				// Обновление данных в rowsList
				this.rowsList = this.rowsList.map(item =>
					item.date === key ? value[key] : item
				);
			}
		},

	},
};
</script>

<style lang="scss">
.calendarEvents {
	padding: 10px;
}

.custom-navigation {
	//display: flex;
	//justify-content: space-between;
	//margin-bottom: 10px;
	button {
		z-index: 10;
		position: absolute;
		padding: 10px;
		border: none;
		border-radius: 3px;
		cursor: pointer;
		top: 26px;
	}
	.previous {
		left: 26px;
	}
	.next {
		right: 26px;
	}
}

.custom-pagination {
	display: flex;
	justify-content: center;
	margin-top: 10px;
	div {
		margin: 0 5px;
		padding: 10px;
		background-color: #ddd;
		cursor: pointer;
		&.active {
			background-color: #1dab39;
			color: white;
		}
	}
}
.salaryHistory {
	position: relative;
	.swiper-slide {
		height: inherit;
		&-active {
			.title {
				padding-right: 57px;
				@media screen and (max-width: 768px) {
					padding-left: 57px;
					padding-right: 0;
				}
			}
		}
		&-next {
			.title {
				padding-left: 57px;
			}
		}
	}
}

</style>
